"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = theme => ({
  listItem: {
    transition: theme.transition(['all']),
    '&.active > $row': {
      background: theme.list.item.active.background,
      '& $leftIcon': {
        '& .fill': {
          fill: theme.list.item.active.color
        },
        '& .stroke': {
          stroke: theme.list.item.active.color
        }
      },
      '& $label': {
        color: theme.list.item.active.color
      }
    }
  },
  row: {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
    position: 'relative',
    cursor: 'pointer',
    height: 40,
    boxSizing: 'border-box',
    padding: '0 12px',
    '&:hover': {
      '& $leftIcon': {
        '& .fill': {
          fill: theme.list.item.hover.color
        },
        '& .stroke': {
          stroke: theme.list.item.hover.color
        }
      },
      '& $label': {
        color: theme.list.item.hover.color
      }
    }
  },
  leftIcon: {
    display: 'inline-block',
    marginRight: 8,
    marginLeft: 8
  },
  label: {
    display: 'inline-block'
  },
  nested: {
    display: 'none',
    '&.show': {
      display: 'block'
    }
  },
  arrow: {
    display: 'inline-block',
    transform: 'rotate(-90deg)',
    transition: theme.transition(['transform']),
    '&.show': {
      transform: 'rotate(0deg)'
    }
  },
  emptyArrow: {
    display: 'inline-block',
    width: 12,
    height: 12
  }
});
exports.default = _default;